import React from 'react';
import { Badge } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-regular-svg-icons';

export default function LlcMatchBadge() {
  return (
    <Badge bg="" className="secondary-outline badge-sm py-0-5">
      <FontAwesomeIcon icon={faBadgeCheck} size="xs" />
      <span className="d-none d-md-inline fs-x-small">Legal Entity Match</span>
      <span className="d-md-none fs-x-small">LLC</span>
    </Badge>
  );
}
